import Parse from 'react-html-parser';
import { useRouter } from 'next/router';

const AdditionalInformation = ({ data }) => {
	const { locale } = useRouter();
	const privacy =
		locale !== 'default'
			? data.replace('/legal/privacy-policy', `/${locale}/legal/privacy-policy`)
			: data;
	return <>{Parse(privacy)}</>;
};
export default AdditionalInformation;
